import { put, takeLatest } from 'redux-saga/effects'

import * as rolesModule from '../reducks/desiredRoles'

import * as rolesApi from '../apiModules/desiredRoles'

function* createRolesSaga(action) {
  try {
    const response = yield rolesApi.createRole(action.payload.id, action.payload.data)
    yield put(rolesModule.createRoleSuccess(response))
  } catch (error) {}
}

function* fetchRolesSaga(action) {
  try {
    const response = yield rolesApi.fetchRoles(action.payload.id)
    yield put(rolesModule.fetchRolesSuccess(response))
  } catch (error) {}
}

function* updateRolesSaga(action) {
  try {
    const response = yield rolesApi.updateRole(action.payload.id, action.payload.data)

    const roles = yield rolesApi.fetchRoles(action.payload.candidate_id)
    yield put(rolesModule.fetchRolesSuccess(roles))

    yield put(rolesModule.updateRoleSuccess(response))
  } catch (error) {}
}

function* deleteRolesSaga(action) {
  try {
    const response = yield rolesApi.deleteRole(action.payload.id)

    const roles = yield rolesApi.fetchRoles(action.payload.candidate_id)
    yield put(rolesModule.fetchRolesSuccess(roles))

    yield put(rolesModule.deleteRoleSuccess(response))
  } catch (error) {}
}

export default function* watchRolesSaga() {
  yield takeLatest(rolesModule.CREATE, createRolesSaga)
  yield takeLatest(rolesModule.FETCH, fetchRolesSaga)
  yield takeLatest(rolesModule.UPDATE, updateRolesSaga)
  yield takeLatest(rolesModule.DELETE, deleteRolesSaga)
}
